import { render } from "./TheQuyenQT.vue?vue&type=template&id=406b64fe"
import script from "./TheQuyenQT.vue?vue&type=script&lang=js"
export * from "./TheQuyenQT.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__